import type {
    RefetchQueriesOptions,
    ApolloQueryResult,
    ApolloCache,
    NormalizedCacheObject,
    RefetchQueriesResult,
} from '@apollo/client';
import { getApolloClientInternal } from './apolloClient';

export function refetchQueries<
    TCache extends ApolloCache<any> = ApolloCache<NormalizedCacheObject>,
    TResult = Promise<ApolloQueryResult<any>>
>(options: RefetchQueriesOptions<TCache, TResult>): RefetchQueriesResult<TResult> {
    return getApolloClientInternal().refetchQueries(options);
}
